<template>
    <div class="container delivery mt-5">
        <div class="row">
            <div class="block-title">Способ доставки</div>
        </div>
        <div class="row">
            <div class="muted mt-2">
                Доставка происходит и оплачивается по прямой договоренности покупателя с транспортной компанией.
                <a href="/content/delivery">Доставка и оплата</a>
            </div>
        </div>
        <div class="row">
            <div class="delivery-list mt-4">

                <template v-for="(item, index) in items">
                    <div class="cell form-check form-check-custom">
                        <input class="form-check-input"
                               :value="item.id"
                               v-model="this.selected"
                               type="radio"
                               name="delivery"
                               :id="'delivery_list_' + item.id">
                        <label class="form-check-label"
                            :for="'delivery_list_' + item.id"
                            v-html="item.name">
                        </label>
                    </div>
                </template>

            </div>
        </div>
    </div>
</template>

<script>

export default {
    methods: {
        getDeliveryMethods() {
            this.$store.dispatch('delivery/getDeliveryMethods');
        }
    },
    computed: {
        items() {
            return this.$store.state.delivery.items;
        },
        selected: {
            get() {
                return this.$store.state.delivery.selected;
            },
            set(value) {
                this.$store.commit('delivery/select', value);
            }
        }
    },
    mounted() {
        this.getDeliveryMethods();
    },
};
</script>
